export default __webpack_public_path__ + "static/2-ab9b3743a16de5f2bda55ed6bb1e650e.jpeg";